import React from 'react'
import { FaArrowUp } from 'react-icons/fa'

export const Balance = () => {
  return (
    <div className='bg-[#F0F0F0] px-4 py-3 rounded-lg dark:bg-[#282828] w-full shrink-0'>
        <p className='opacity-60'>Current Account Balance</p>
        <h1 className='dark:text-white font-semibold text-[28px] py-2'>$1,455.89</h1>
        <div className='flex items-center space-x-1 text-[#1D6528] dark:text-[#CBF0D0] bg-white dark:bg-[#1C1C1C] p-[5px] rounded-lg w-fit'>
            <FaArrowUp/>
            <p>12.2%</p>
        </div>
    </div>
  )
}
